import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_TPA_API_URL,
  withCredentials: true
})

// Redirect to login on 401 (expired/missing cookie)
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.location.hash = '#/pages/login'
    }
    return Promise.reject(error)
  }
)

export default instance
